module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_2257', { 

	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/sitepage/2257.js
// module id = 131
// module chunks = 4